import DialogSimple from './DialogSimple'

export default DialogSimple
